import React from "react";
import { useGetAssignmentMarksQuery } from "../../features/assignments/assignemntsApi";
import Error from "../ui/Error";
import Loading from "../ui/Loading";
import SingleAssignmentMarking from "./SingleAssignmentMarking";

export default function AssignmentMarkingList() {
  const {
    data: assignmentMarks,
    isLoading,
    isError,
    error,
  } = useGetAssignmentMarksQuery();

  const getPendingAssignment = () => {
    return assignmentMarks?.filter(
      (assignmentMark) => assignmentMark.status === "pending"
    );
  };
  const getMarkSent = () => {
    return assignmentMarks?.filter(
      (assignmentMark) => assignmentMark.status === "published"
    );
  };

  // decide what to render
  let content = null;
  if (isLoading) {
    content = <Loading />;
  } else if (!isLoading && isError) {
    content = <Error message={error} />;
  } else if (!isLoading && !isError && assignmentMarks.length === 0) {
    content = (
      <div style={{ textAlign: "center", fontSize: "18px" }}>
        No assignment found!
      </div>
    );
  } else if (!isLoading && !isError && assignmentMarks.length > 0) {
    content = (
      <table className="divide-y-1 text-base divide-gray-600 w-full">
        <thead>
          <tr>
            <th className="table-th">Assignment</th>
            <th className="table-th">Date</th>
            <th className="table-th">Student Name</th>
            <th className="table-th">Repo Link</th>
            <th className="table-th">Mark</th>
          </tr>
        </thead>

        <tbody className="divide-y divide-slate-600/50">
          {assignmentMarks?.map((assignmentMark) => (
            <SingleAssignmentMarking
              key={assignmentMark.id}
              assignmentMark={assignmentMark}
            />
          ))}
        </tbody>
      </table>
    );
  }
  return (
    <>
      <ul className="assignment-status">
        <li>
          Total <span>{assignmentMarks?.length}</span>
        </li>
        <li>
          Pending <span>{getPendingAssignment()?.length}</span>
        </li>
        <li>
          Mark Sent <span>{getMarkSent()?.length}</span>
        </li>
      </ul>
      <div className="overflow-x-auto mt-4">{content}</div>
    </>
  );
}
